module.exports = __webpack_public_path__ + "img/magnifying-glass.d1ee85d0.svg";